import {closeCurrentDialog} from 'platform/components';

import {useCreateQuickPresetMutation} from '@dms/api/settings';
import {handleApiError} from '@dms/shared';

import {CreateQuickPresetForm, CreateQuickPresetFormProps} from './CreateQuickPresetForm';

interface CreateQuickPresetDialogProps {
  onSubmit: (value: {id: string; name: string}) => void;
}

export function CreateQuickPresetDialog(props: CreateQuickPresetDialogProps) {
  const [createQuickPreset] = useCreateQuickPresetMutation();

  const onSubmit: CreateQuickPresetFormProps['onSubmit'] = (values) =>
    createQuickPreset({
      body: values,
    })
      .unwrap()
      .then((response) => props.onSubmit({id: response.id, name: values.name}))
      .then(() => closeCurrentDialog())
      .catch(handleApiError);

  return <CreateQuickPresetForm onSubmit={onSubmit} />;
}
